import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HeaderComponent } from './components/header/header.component';
import { ProductDescriptionComponent } from './components/product-description/product-description.component';
import { ProductInformationComponent } from './components/product-information/product-information.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { RequestComponent } from './components/request/request.component';
import { AppService } from './shared/services/app.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { FormsModule } from "@angular/forms";
import { ProductOverviewComponent } from './components/product-overview/product-overview.component';
import { MomentPipe } from './shared/pipes/moment.pipe';
import { RequestService } from './shared/services/request.service';
import { StatusComponent } from './components/status/status.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { InfoDialogComponent } from './components/product-information/info-dialog/info-dialog.component';
import { ProductNotFoundComponent } from './components/product-not-found/product-not-found.component';
import { BannerComponent } from './components/banner/banner.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RequestInterceptor } from './shared/interceptors/request.interceptor';
import { DeviceCoverageComponent } from './components/device-coverage/device-coverage.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ProductDescriptionComponent,
    ProductInformationComponent,
    ProgressBarComponent,
    RequestComponent,
    ProductOverviewComponent,
    MomentPipe,
    StatusComponent,
    ConfirmComponent,
    InfoDialogComponent,
    ProductNotFoundComponent,
    BannerComponent,
    DeviceCoverageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    HttpClientModule,
    FormsModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AppService, 
    RequestService, 
    ReCaptchaV3Service,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
